export const StyledHeaderBox = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  mb: 2,
} as const;

export const StyledHeaderTitle = {
  variant: "h5",
  fontWeight: 700,
  mb: 0.5,
} as const;

export const StyledHeaderSubtitle = {
  variant: "body2",
  color: "text.secondary",
} as const;

export const StyledStatsGrid = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
  gap: 2,
  mb: 3,
} as const;

export const StyledUserInfoHeader = {
  px: 3,
  py: 2,
  borderBottom: "1px solid",
  borderColor: "divider",
} as const;

export const StyledUserInfoStack = {
  px: 3,
  py: 2,
} as const;
